import { createBrowserRouter } from "react-router-dom";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";
import JoinPage from "./pages/JoinPage";
import Landing from "./pages/Landing";
import NotFound from "./pages/NotFound";
import Play from "./pages/Play";
import Scoreboard from "./pages/Scoreboard";
import RequireAdmin from "./routes/RequireAdmin";

const GAME_CODE = import.meta.env.VITE_GAME_CODE || "CTF2025";

export const router = createBrowserRouter([
  { path: "/", element: <Landing /> },
  { path: "/admin/login", element: <AdminLogin /> },
  {
    path: "/admin",
    element: (
      <RequireAdmin>
        <AdminDashboard gameCode={GAME_CODE} />
      </RequireAdmin>
    ),
  },
  { path: "/join/:code", element: <JoinPage /> },
  { path: "/play/:gameCode", element: <Play /> },
  { path: "/scoreboard/:gameCode", element: <Scoreboard /> },
  /* Anything else lands on a real page rather than a blank screen. */
  { path: "*", element: <NotFound /> },
]);
